import { toValue, watch, type WatchHandle } from 'vue'
import { isSameRoute, type RefOrGetter } from '@/helpers'
import {
    type RouteLocationNormalizedLoadedGeneric,
    type RouteLocationResolvedGeneric,
    useRouter,
} from 'vue-router'
import { useRedirect } from 'wucdbm-vite-vue-ssr'

type RoutePathWatcher = () => Promise<WatchHandle>

export function useRoutePathWatcher(
    currentRouteParsed: RefOrGetter<RouteLocationResolvedGeneric>,
    getPathFunction: () => string,
    code: 301 | 302
): RoutePathWatcher {
    const router = useRouter()
    const redirect = useRedirect()

    return async (): Promise<WatchHandle> => {
        const redirectIfNeeded = async ([parsed, current]: [
            RouteLocationResolvedGeneric,
            RouteLocationNormalizedLoadedGeneric,
        ]) => {
            if (!isSameRoute(parsed, current)) {
                return
            }

            if (parsed.path !== current.path) {
                await redirect(getPathFunction(), code)
            }
        }

        const handle = watch(
            [currentRouteParsed, router.currentRoute],
            redirectIfNeeded
        )

        await redirectIfNeeded([
            toValue(currentRouteParsed),
            router.currentRoute.value,
        ])

        return handle
    }
}
